import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, authHeaders } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Store, ChevronRight, Heart, Loader2 } from "lucide-react";

export default function ClientFavorites() {
  const navigate = useNavigate();
  const { client } = useAuth();
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!client) { setLoading(false); return; }
    api.get("/client/following", { headers: authHeaders("client") })
      .then((r) => setStores(r.data.stores || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [client]);

  return (
    <div className="kn-fade-up space-y-4" data-testid="favorites-page">
      <div className="flex items-center gap-2">
        <Heart className="h-6 w-6 text-[#E63946] fill-[#FFE4E6]" />
        <h1 className="text-2xl font-extrabold text-slate-900">Preferiti</h1>
      </div>
      <p className="text-sm text-slate-500 -mt-2">I negozi che segui</p>

      {!client ? (
        <div className="kn-card p-8 text-center" data-testid="favorites-login">
          <Heart className="h-10 w-10 text-slate-300 mx-auto mb-3" />
          <p className="text-slate-500 text-sm">Accedi per vedere i negozi che segui.</p>
        </div>
      ) : loading ? (
        <div className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-[#E63946]" /></div>
      ) : stores.length === 0 ? (
        <div className="kn-card p-8 text-center" data-testid="favorites-empty">
          <Heart className="h-10 w-10 text-slate-300 mx-auto mb-3" />
          <p className="text-slate-700 font-semibold">Nessun preferito</p>
          <p className="text-slate-400 text-sm mt-1">Segui i tuoi negozi preferiti per ritrovarli qui e ricevere le loro novità.</p>
          <button onClick={() => navigate("/")} data-testid="favorites-explore" className="mt-4 h-11 px-5 rounded-xl kn-gradient text-white font-bold">
            Scopri le offerte
          </button>
        </div>
      ) : (
        <div className="space-y-2.5" data-testid="favorites-list">
          {stores.map((s) => (
            <button
              key={s.vendor_id}
              data-testid={`favorite-${s.vendor_id}`}
              onClick={() => navigate(`/store/${s.vendor_id}`)}
              className="w-full kn-card p-3 flex items-center gap-3 text-left hover:shadow-md transition-shadow"
            >
              <div className="h-12 w-12 rounded-xl bg-slate-50 overflow-hidden flex items-center justify-center shrink-0">
                {s.logo ? <img src={s.logo} alt="" className="h-full w-full object-cover" /> : <Store className="h-6 w-6 text-slate-300" />}
              </div>
              <div className="min-w-0 flex-1">
                <p className="font-bold text-slate-800 truncate">{s.store_name}</p>
                <p className="text-xs text-slate-400">{s.active_count} offerte attive</p>
              </div>
              <ChevronRight className="h-5 w-5 text-slate-300 shrink-0" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
